/**
 * @lodex-pro/web-portal/routes/Reports — the operator's reports (operator Reports (c), 0256).
 *
 * The period statement PDF, and below it the admin's scheduled emailed report (option b, 0257).
 * Every operator role: an admin's statement covers the company, a pumper's or foreman's their
 * own tanks (the API's scope, 0215). The plan gate is the CSV / Excel export's: OP_TICKETS and
 * OP_REPORTS. The API refuses without them too; this is the UX, not the gate.
 */

import React from 'react';
import { usePortalMe } from '../hooks/useOperatorPortal';
import { portalIsAdmin, portalLacks } from '../nav/portal-features';
import { StatementCard } from '../components/reports/StatementCard';
import { ReportSchedulesCard } from '../components/reports/ReportSchedulesCard';
import { PremiumStub } from './PremiumStub';

export function Reports(): React.JSX.Element {
  const me = usePortalMe();
  if (me.data === undefined) {
    return (
      <main style={{ padding: '24px' }}>
        {me.isError ? <p role="alert">Could not load reports.</p> : <p role="status">Loading…</p>}
      </main>
    );
  }
  if (portalLacks(me.data, 'OP_TICKETS') || portalLacks(me.data, 'OP_REPORTS')) {
    return <PremiumStub feature="reports" />;
  }
  return (
    <main style={{ padding: '24px', maxWidth: '960px', margin: '0 auto' }}>
      <h1 style={{ marginBottom: '16px' }}>Reports</h1>
      <StatementCard />
      {/* Operator Reports (b) — the scheduled emailed report: the admin's only (0257). */}
      {portalIsAdmin(me.data) && <ReportSchedulesCard />}
    </main>
  );
}
